/** First http(s) URL in the text, with trailing punctuation ()).,!]) stripped; null if none. */
export function extractSharedUrl(text: string): string | null {
  const match = text.match(/https?:\/\/\S+/);
  if (!match) {
    return null;
  }

  // Strip trailing punctuation chars
  let url = match[0];
  url = url.replace(/[).,!\]]+$/, "");

  return url;
}

/** Hostname of a URL for display (e.g. confirm cards); falls back to the raw input if unparseable. */
export function hostnameOf(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

/** Resolves the effective shared URL/text from share_target query params. */
export function parseSharePayload(params: URLSearchParams): {
  url: string | null;
  text: string;
  title: string;
} {
  const urlParam = params.get("url");
  const textParam = params.get("text") ?? "";
  const titleParam = params.get("title") ?? "";

  // Determine effective URL: url param wins if valid http(s), else extract from text
  const effectiveUrl =
    urlParam && (urlParam.startsWith("http://") || urlParam.startsWith("https://"))
      ? urlParam
      : extractSharedUrl(textParam);

  return {
    url: effectiveUrl,
    text: textParam.trim(),
    title: titleParam.trim(),
  };
}
